import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import { resetPwaInstallDismissed } from './lib/pwaInstall';
import { installImageWatchdog } from './lib/imageWatchdog';

// Test-affordance: ?reset-pwa-banner=1 clears the localStorage flag
// that suppresses the install banner. Lets a tester (Alexey) re-trigger
// the prompt without DevTools. We strip the param after consuming it so
// the URL stays clean for subsequent navigation.
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  if (params.has('reset-pwa-banner')) {
    resetPwaInstallDismissed();
    params.delete('reset-pwa-banner');
    const qs = params.toString();
    const newUrl = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }
}

// Залипшие фото из S3 перезапрашиваем сами (#3285).
installImageWatchdog();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
